import { z } from 'zod';
import { makeFieldSchemaFromZod } from '../../utils/index.esm.js';

const ResourcePickerFieldSchema = makeFieldSchemaFromZod(
  z.object({}),
  z.object({
    catalogFilter: z.object({
      kind: z.array(z.string()).optional().describe("List of key-value filter expression for entities"),
      allowedResources: z.array(z.string().optional().describe("List of allowed resources")),
      type: z.string().optional().describe("List of type filter expression for entities")
    })
  })
);
const ResourcePickerSchema = ResourcePickerFieldSchema.schema;

export { ResourcePickerFieldSchema, ResourcePickerSchema };
//# sourceMappingURL=schema.esm.js.map
